import React from 'react';
import { X, Download, Shield, CheckCircle2 } from 'lucide-react';

const DownloadModal = ({ onClose, onDownload }) => (
  <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="download-modal">
    <div className="absolute inset-0 bg-black/70" onClick={onClose} />
    <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <Download className="w-5 h-5 text-blue-600" />
          Você está prestes a baixar o programa SHOficina.
        </h3>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 p-1" data-testid="download-modal-close">
          <X className="w-5 h-5" />
        </button>
      </div>
      {/* Body */}
      <div className="px-6 py-5 space-y-6">
        <div>
          <p className="text-gray-600 text-sm mb-3">Ao clicar em download seu sistema começará a baixar o programa conforme imagem abaixo:</p>
          <div className="bg-gray-800 rounded-lg p-3 flex items-center gap-3">
            <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center flex-shrink-0">
              <img src="./shoficina-logo.png" alt="" className="w-5 h-5 object-contain" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-medium">shoficina6.exe</p>
              <p className="text-gray-400 text-xs">45,8 MB - Baixando...</p>
              <div className="w-full bg-gray-700 rounded-full h-1.5 mt-1.5">
                <div className="bg-blue-500 h-1.5 rounded-full w-1/3" />
              </div>
            </div>
            <Download className="w-5 h-5 text-blue-400 flex-shrink-0" />
          </div>
        </div>
        <div>
          <p className="text-gray-600 text-sm mb-3">Após concluído basta clicar nele para abrir.</p>
          <div className="bg-gray-800 rounded-lg p-3 flex items-center gap-3">
            <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center flex-shrink-0">
              <img src="./shoficina-logo.png" alt="" className="w-5 h-5 object-contain" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-medium">shoficina6.exe</p>
              <p className="text-green-400 text-xs flex items-center gap-1">
                <CheckCircle2 className="w-3 h-3" /> 45,8 MB - Concluído
              </p>
            </div>
            <span className="text-green-400 text-xs font-medium bg-green-500/10 px-2 py-1 rounded">Abrir</span>
          </div>
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <p className="text-blue-700 text-xs flex items-center gap-2">
            <Shield className="w-4 h-4 flex-shrink-0" />
            Arquivo seguro e verificado. Compatível com Windows 7, 8, 10 e 11.
          </p>
        </div>
      </div>
      {/* Footer */}
      <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
        <a href="./downloads/shoficina6.exe" download="shoficina6.exe" onClick={onDownload}
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold px-6 py-2.5 rounded-lg transition-colors shadow-lg shadow-blue-500/30"
          data-testid="download-exe-btn">
          <Download className="w-4 h-4" /> Download
        </a>
        <button onClick={onClose}
          className="px-6 py-2.5 text-gray-600 hover:text-gray-800 font-medium border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
          data-testid="download-modal-fechar">
          Fechar
        </button>
      </div>
    </div>
  </div>
);

export default DownloadModal;
